const rootActionPath = 'core/bonusTerms';

export const BONUS_TERMS_VIEW = `${rootActionPath}/VIEW`;
